<template>
  <div class="wizard-content">
    <div class="wizard-content__column">
      <address-form />
    </div>
    <div class="wizard-content__column">
      <component-data :title="trans.get('wizard.contactTitle')">
        <form>
            <floating-input
            name="email"
            :placeholder="trans.get(`wizard.${fields.email.name}`)"
            :initialValue="fields.email.value"
            :initialErrors="fields.email.errors"
            @handle-change="handlePersonalChange"
            :type="fields.email.type"
            class="mt-2"
          ></floating-input>
          <div class="flex mt-2">
            <v-select
                class="min-width-8"
                :options="phonePrefixes"
                :class="{ 'error-border': fields.phone_prefix.errors.length }"
                :placeholder="trans.get('wizard.phone_prefix')"
                @input="handlePhonePrefix"
                :value="fields.phone_prefix.value"
            >
            <template #option="{ label, icon }">
              <div class="flex items-center"><span class="mr-2">{{ label }}</span> <img loading="lazy" class="h-4" :src="`/img/flags/${icon}.png`"></div>
            </template>
          </v-select>
          <floating-input
          name="phone"
          :placeholder="trans.get(`wizard.${fields.phone.name}`)"
          :initialValue="fields.phone.value"
          :initialErrors="fields.phone.errors"
          @handle-change="handlePersonalChange"
          :type="fields.phone.type"
          class="ml-4 w-full"
          ></floating-input>
        </div>
        <div v-if="fields.phone_prefix.errors.length" class="text-error text-sm mt-1">
          {{ fields.phone_prefix.errors[0] }}
        </div>

          <floating-input
                v-if="isCanarias"
                name="dni"
                :placeholder="trans.get(`wizard.${fields.dni.name}`)"
                :initialValue="fields.dni.value"
                :initialErrors="fields.dni.errors"
                @handle-change="handlePersonalChange"
                :type="fields.dni.type"
                class="lg:ml-4 mt-2 w-full"
            ></floating-input>
        </form>
      </component-data>
      <component-data :title="trans.get('wizard.shipmentTitle')" class="mt-6">
        <div class="shipment-container">
          <input
            type="radio"
            id="standard"
            value="standard"
            v-model="shipingdata"
          />
          <label for="standard" class="w-full">
            <div class="shipment-container__label">
              <div class="in-row">
                <span>Standard</span>
                <span v-if="remaining > 0">{{ shippingType.cost | currency }}</span>
                <span v-else class="font-bold">{{ trans.get('wizard.free') }}</span>
              </div>
              <span class="mt-2 font-medium">{{
                trans.get(`wizard.delivery.${shippingType.method}`)
              }}</span>
              <span v-if="remaining > 0" class="mt-2 font-medium text-base">
                {{ trans.get("wizard.free_shipping.p1") }}
                {{
                  (parseFloat(shippingType.free_shipping_from) -
                    parseFloat(subtotal))
                    | currency
                }}
                {{ trans.get("wizard.free_shipping.p2") }}</span
              >
            </div>
          </label>
        </div>
      </component-data>
      <btn-primary
        :disabled="!formIsValid"
        :handle-click="handleNext"
        :text="trans.get('wizard.btnText')"
        class="mt-12"
      ></btn-primary>
    </div>
  </div>
</template>

<script>
import {
  GET_ADDRESS_DATA,
  SET_ADDRESS_DATA_MUTATION,
  GET_PERSONAL_DATA,
  SET_PERSONAL_DATA_MUTATION,
  GET_SHIPMENT_DATA,
  SET_SHIPMENT_DATA_MUTATION,
  GET_PERSONAL_VALID,
  GET_ADDRESS_VALID,
  GET_REGIONS,
  RETREIVE_SHIPPING_TYPE,
  GET_SHIPPING_TYPE,
  GET_FIELDS,
  GET_PHONE_PREFIX_VALID,
GET_IS_CANARIAS,
} from "../../../store/wizard/types";
import { GET_SUBTOTAL } from "../../../store/cart/types";
import mixin from "../../../mixin";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { phonePrefixes } from "../../../phonePrefixes";

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters({
      addressForm: GET_ADDRESS_DATA,
      personalData: GET_PERSONAL_DATA,
      personalValid: GET_PERSONAL_VALID,
      phonePrefix: GET_PHONE_PREFIX_VALID,
      addressValid: GET_ADDRESS_VALID,
      regions: GET_REGIONS,
      shippingType: GET_SHIPPING_TYPE,
      subtotal: GET_SUBTOTAL,
      fields: GET_FIELDS,
      isCanarias: GET_IS_CANARIAS
    }),
    shipingdata: {
      get() {
        return this.$store.getters[GET_SHIPMENT_DATA];
      },
      set(value) {
        this.setShipmentData(value);
      },
    },
    remaining(){
      return parseFloat(this.shippingType.free_shipping_from) - parseFloat(this.subtotal);
    },
    costText(){
      return this.remaining >= 0 ? (this.shippingType.cost | this.currency) : 'Gratis'
    },
    formIsValid() {
      return this.personalValid && this.addressValid;
    },
  },
  data: () => {
    return {
        phonePrefixes: phonePrefixes
    };
  },
  watch: {
    formIsValid(valid) {
      if (!valid) {
        this.$store.commit("steps/setStepsMaxIndex", "personal-data");
      }
    },
  },
  methods: {
    ...mapMutations({
      setAddressData: SET_ADDRESS_DATA_MUTATION,
      setPersonalData: SET_PERSONAL_DATA_MUTATION,
      setShipmentData: SET_SHIPMENT_DATA_MUTATION,
    }),
    ...mapActions({
      retreiveShippingType: RETREIVE_SHIPPING_TYPE,
    }),
    handlePhonePrefix(payload) {
      if (payload && payload.code) {
        this.setPersonalData({
          ...this.personalData,
          phone_prefix: {
            ...this.personalData.phone_prefix,
            value: payload.code,
            errors: []
          },
        });
      } else {
        this.setPersonalData({
          ...this.personalData,
          phone_prefix: {
            ...this.personalData.phone_prefix,
            value: "",
            errors: [this.trans.get('wizard.phone_prefix_error')]
          },
        });
      }
    },
    handleAddressChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        personal: {
          ...this.addressForm["personal"],
          [payload.name]: {
            ...this.addressForm["personal"][payload.name],
            value: payload.value,
          },
        },
      });
    },
    handlePersonalChange(payload) {
      this.setPersonalData({
        ...this.personalData,
        [payload.name]: {
          ...this.personalData[payload.name],
          value: payload.value,
        },
      });
    },
    handlePostalChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        postal_code: {
          ...this.addressForm["postal"],
          value: payload.value,
        },
      });
      this.retreiveShippingType(this.addressForm);
    },
    handleCityChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        city: {
          ...this.addressForm["city"],
          value: payload,
        },
      });
      this.retreiveShippingType(this.addressForm);
    },
    handleCountryChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        country: {
          ...this.addressForm["country"],
          value: payload,
        },
      });
      this.retreiveShippingType(this.addressForm);
    },
    handleNext() {
  if (!this.personalValid) return; 
  if (!this.phonePrefix) {
    this.setPersonalData({
      ...this.personalData,
      phone_prefix: {
        ...this.personalData.phone_prefix,
        errors: [this.trans.get('wizard.phone_prefix_error')]
      }
    });
    return;
  }

  this.$router.push({
    name: "resume-payment",
    params: { lang: this.lang },
  });
},
  },
  mounted() {
    // window.onbeforeunload = () => {
    //   return this.trans.unsavedChanges[this.lang];
    // };
    this.retreiveShippingType(this.addressForm);
  },
};
</script>
<style lang="scss">
.v-select.error-border .vs__dropdown-toggle {
  border: 1px solid #b10000; 
}
.shipment-container {
  margin-top: 2rem;
  display: flex;
  align-items: center;

  &.no-input {
    margin-top: 0;
    .shipment-container__label {
      margin-left: 0;
    }
  }

  &__label {
    display: flex;
    flex-direction: column;
    margin-left: 1.2rem;
    font-size: 18px;
    .in-row {
      font-weight: bold;
      display: flex;
      justify-content: space-between;
    }
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #000;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 19px;
    height: 19px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: "";
    width: 10px;
    height: 10px;
    background: #3a473c;
    position: absolute;
    top: 4px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.v-select {
  height: 48px;
  margin-top: 1.5rem;
  .vs__dropdown-toggle {
    border-radius: 0;
    border: 1px solid #bfbfbf;
    padding: 8px;
    width: 100%;
    height: 100%;
    background-color: transparent;
    color: #999;
    cursor: text;
  }
}
</style>
